var tagOptions;
(function (tagOptions) {
  tagOptions["KEEP_AND_REUSE"] = "Reuse";
  tagOptions["THROW_AND_RECEIVE_DEPOSIT"] = "Throw";
})(tagOptions || (tagOptions = {}));
export default tagOptions;